module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre1"
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Mary Lane sah erschrocken auf ihre goldene Armbanduhr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Vier Uhr, mein Lieber!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Es tanzten immerhin noch etwa zwanzig Paare auf dem Parkett des Gesandtschafts-Klubs. Es war ein Galaabend, und bei solchen Festen wurde es immer sehr spät.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Tut mir leid, daß es so ein langweiliger Abend war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Aber Dick Allenby sah nicht gelangweilt aus. Er hatte freundliche blaue Augen und ein faltenloses, sonnengebräuntes Gesicht, obwohl er in den letzten vierundzwanzig Stunden nicht geschlafen hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre3 pcalibre1",
    attrs: {
      "id": "page12",
      "title": "gary/isenheim"
    }
  }), _vm._v(" Auf jeden Fall hast du mich gerettet, sagte er und winkte einem Kellner. Bis du kamst, war ich ganz allein. Ich habe geschwindelt, als ich dir erzählte, daß Moran hier war und später wegging. Der Junge war überhaupt nicht da. Jerry Dornford sucht Anschluß – er scheint die Hoffnung noch nicht aufgegeben zu haben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Er sah zu einem Tisch auf der anderen Seite des Tanzsaals hinüber, wo der tadellos gekleidete Jerry saß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Ich kenne ihn kaum, entgegnete Mary.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Er lächelte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Er möchte dich eben besser kennenlernen, aber ich kann dir nur den guten Rat geben, ihm aus dem Weg zu gehen. Jerry entfernte sich kurz vor dem Abendessen und ist erst vor kurzem wieder aufgetaucht. Die Gesellschaft, die du besucht hast, war wohl auch nicht sehr anregend, was? Dieser Wirth ist doch ein ganz merkwürdiger Kerl. Ich muß sagen, Mike Hennessey hat sich ziemlich viel herausgenommen, daß er dich dazu eingeladen hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Aber Mike ist ein netter Mensch, protestierte sie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Mike ist ein Verbrecher. Ein liebenswürdiger Charakter, aber doch ein Verbrecher. Solange der frei herumläuft, ist es eine Schande, daß andere Leute im Gefängnis sitzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Sie traten auf die Straße hinaus, und während sie auf ein Taxi warteten, sah Dick Allenby ein bekanntes Gesicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Mr. Smith, Sie sind noch so spät auf den Beinen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Sie meinen so früh am Morgen, entgegnete der Detektiv und begrüßte die junge Dame.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Guten Morgen, Miss Lane. Eigentlich keine gute Angewohnheit, in einen Nachtklub zu gehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Ich habe eine ganze Menge schlechter Angewohnheiten, erwiderte sie lächelnd.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Ein Taxi fuhr vor. Mary lehnte Dicks Begleitung ab, und der Wagen entfernte sich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Nette junge Dame, bemerkte der Chefinspektor. Schauspielerinnen mag ich im allgemeinen nicht – ich komme gerade von der Marlborough Street, wo ich drei verhaftet habe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Haben Sie eine kleine Razzia abgehalten?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre3 pcalibre1",
    attrs: {
      "id": "page13",
      "title": "gary/isenheim"
    }
  }), _vm._v(" Ach, es war nichts von Bedeutung. Übrigens wäre ich neulich beinahe in Ihre Werkstätte gekommen und hätte mir Ihre neue Schußwaffe angesehen. Ist doch wohl eine Art Luftgewehr?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Ja. Wer hat Ihnen denn davon erzählt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Dieser Dornford. Ich verstehe die Mechanik Ihrer neuen Pistole nicht. Dornford sagt, daß bei jedem Abfeuern die Waffe neu geladen wird.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Durch das Abfeuern erhalte ich komprimierte Luft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Dick Allenby war nicht in der Stimmung, über seine Erfindung zu sprechen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Das Ding sollten Sie nach Chikago verkaufen, dort haben die Leute großes Interesse an solchen Sachen. Jede Woche werden mindestens sechs Leute umgebracht, und die Polizei fängt niemand!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Dick lachte. Er war erst vor einem Monat aus Chikago zurückgekehrt und kannte die schweren Aufgaben, die die Polizei drüben zu lösen hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Wenn einer umgebracht werden soll, fuhr Smith fort, machen sie mit ihm eine Spazierfahrt aufs Land und jagen ihm unterwegs eine Kugel durch den Kopf. So etwas wäre hier einfach nicht möglich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("In der Beziehung bin ich etwas skeptisch. Dick schüttelte den Kopf. Aber es ist beinahe halb fünf, und ich möchte mich jetzt nicht länger über Verbrechen unterhalten. Kommen Sie mit in meine Wohnung, dort können wir noch ein Glas trinken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Schön, ich begleite Sie. Schlafen kann ich doch nicht mehr. Dort steht ein Taxi.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Das Auto stand mitten auf der Straße neben einer Verkehrsinsel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Smith pfiff. Der Chauffeur ist fortgegangen, sagte der Portier des Nachtklubs. Ich habe schon vorhin versucht, den Wagen für die Dame zu rufen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Der Kerl schläft wahrscheinlich, meinte Smith und ging über die Straße. Dick folgte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Der Chefinspektor sah durch das geschlossene Fenster, konnte aber im Innern nichts erkennen. Als er schließlich die Tür aufmachte, sah er jemand am Boden liegen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre3 pcalibre1",
    attrs: {
      "id": "page14",
      "title": "gary/isenheim"
    }
  }), _vm._v(" Der Mensch scheint sinnlos betrunken zu sein! rief Smith und leuchtete die Gestalt mit seiner Lampe an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Das Gesicht war grauenvoll entstellt, denn der Mann hatte aus nächster Nähe einen Schuß in den Kopf erhalten. Aber Smith erkannte trotzdem, daß Mr. Horace Tom Tickler tot in diesem Wagen lag.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Was, den hat man auch auf eine Spazierfahrt mitgenommen? fragte der Chefinspektor verstört. Großer Gott, wir leben doch nicht in Chikago!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0